var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6326_37859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.409547 10.6919H11.1288C11.2249 10.6919 11.3178 10.6582 11.3915 10.5969C11.4945 10.5107 13.8431 8.49032 13.9863 4.12907H2.47404C2.33138 8.08791 0.168446 9.94868 0.145969 9.96724C0.0141932 10.0786 -0.0342895 10.2605 0.0249945 10.4223C0.0838682 10.5837 0.237301 10.6919 0.409547 10.6919Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5898 1.66801H11.5389V1.25783C11.5389 1.02813 11.3585 0.847656 11.1288 0.847656C10.8991 0.847656 10.7186 1.02813 10.7186 1.25783V1.66801H8.64038V1.25783C8.64038 1.02813 8.4599 0.847656 8.23021 0.847656C8.00051 0.847656 7.82003 1.02813 7.82003 1.25783V1.66801H5.76916V1.25783C5.76916 1.02813 5.58868 0.847656 5.35898 0.847656C5.12928 0.847656 4.94881 1.02813 4.94881 1.25783V1.66801H2.89793C2.66824 1.66801 2.48776 1.84848 2.48776 2.07818V3.3087H14V2.07818C14 1.84848 13.8195 1.66801 13.5898 1.66801Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9183 11.2258C11.6955 11.4113 11.416 11.5123 11.1288 11.5123H2.48775V12.7428C2.48775 12.9695 2.67121 13.153 2.89793 13.153H13.5898C13.8165 13.153 14 12.9695 14 12.7428V8.14483C13.2092 10.085 12.1056 11.069 11.9183 11.2258Z",
    fill: "#A9A9A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6326_37859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar01);
export default __webpack_public_path__ + "static/media/calendar-01.a42c5bea8fa9d6e2837421ef10ca730a.svg";
export { ForwardRef as ReactComponent };